/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Audio_Embed_AriaInputs */



/**
* | output |
* | --- |
* | "Embed audio description track into broadcast media file" |
*
* @param {File_Export_Audio_Embed_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_audio_embed_aria = /** @type {((inputs?: File_Export_Audio_Embed_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Audio_Embed_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Intégrer la piste de description audio dans le fichier multimédia de diffusion")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiobeschreibungsspur in die Sendemediendatei einbetten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incorporare la traccia di descrizione audio nel file multimediale di trasmissione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Встроить аудиодорожку с описанием в медиафайл для трансляции.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar pista de audiodescripción en archivo multimedia de difusión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将音频描述轨道嵌入广播媒体文件中")
	if (locale === "ja") return /** @type {LocalizedString} */ ("放送メディアファイルに音声解説トラックを埋め込む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रसारण मीडिया फ़ाइल में ऑडियो विवरण ट्रैक एम्बेड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incorporar faixa de audiodescrição em arquivo de mídia para transmissão")
	return /** @type {LocalizedString} */ ("Embed audio description track into broadcast media file")
});